import {
  DownloadFile,
  DownloadName
} from '../../main/downloads/downloadsTypes';

import { BaseException } from '../../api/common/utils/exceptions/BaseException';
import { Files } from '../Files';

export interface DownloadFileItem {
  name: DownloadName;
  file: DownloadFile;
}

export interface DownloadFileOptions {
  downloadFile: DownloadFileItem;
  parseResponseError?: (response: Response) => Promise<Error | null>;
  onError?: (error: Error) => void;
  withBlob?: boolean;
}

async function downloadFile({
  downloadFile,
  parseResponseError,
  onError,
  withBlob = false
}: DownloadFileOptions): Promise<void> {
  if (typeof window === 'undefined' || !window?.document?.body) {
    return null;
  }

  try {
    const response = await fetch(downloadFile.file);

    if (!response.ok) {
      const responseError = await parseResponseError?.(response);

      if (responseError) {
        throw responseError;
      }

      throw new BaseException(response.status, response.statusText);
    }

    const link = document.createElement('a');

    let url = downloadFile.file;

    if (
      withBlob ||
      Files.isPDF(url) ||
      Files.isImage(url) ||
      Files.isVideo(url)
    ) {
      const blob = await response.blob();
      url = window.URL.createObjectURL(blob);

      link.download = downloadFile.name;
    }

    link.href = url;
    // link.target = '_blank';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    if (withBlob) {
      setTimeout(() => window.URL.revokeObjectURL(url), 100);
    }
  } catch (error) {
    onError?.(error);

    console.error('File downloading error: ', error);
  }
}

export default downloadFile;
